import { reactive, provide, inject } from 'vue';
import { PsProvider } from '../core/PsProvider';
import PsApiService from '@/api/PsApiService';
import Product from '@/object/Product';
import PsResource from '@/api/common/PsResource';
import AddToCartParameterHolder from '@/object/holder/AddToCartParameterHolder';

export class AddToCartItemProvider extends PsProvider {

    isNoMoreRecord = reactive<Boolean>(false);
    AddToCartItemList = reactive<PsResource<Product[]>>(new PsResource());
    item = reactive<PsResource<Product>>(new PsResource());
    loading = reactive({
        value: false
    });

    limit: Number = 10;
    offset: Number = 0;

    id: string = "";
  static AddToCartItemList: any;

    private updateItemList(responseData: PsResource<Product[]>) {

        if (this.AddToCartItemList != null
            && this.AddToCartItemList.data != null
            && this.AddToCartItemList.data.length > 0
            && this.offset != 0) {

            if (responseData.data != null && responseData.data.length > 0) {
                this.AddToCartItemList.data.push(...responseData.data);
            }else {
                this.isNoMoreRecord = true;
            }
            this.AddToCartItemList.code = responseData.code;
            this.AddToCartItemList.status = responseData.status;
            this.AddToCartItemList.message = responseData.message;

        } else {

            this.AddToCartItemList = responseData;


        }

        if (this.AddToCartItemList != null && this.AddToCartItemList.data != null) {
            this.offset = this.AddToCartItemList.data.length;
        }

    }
    async loadItem(itemId: string, loginUserId: string) {

        this.loading.value = true;
        
        this.item = await PsApiService.getItemDetail<Product>(new Product(), itemId, loginUserId);
    
        this.loading.value = false;

        return this.item;

    }

    async loadAddToCartItemList( loginUserId: string) {

        this.loading.value = true;

        this.offset = 0;
        
        const responseData = await PsApiService.getAddToCartList<Product>(new Product(), loginUserId); 
      console.log(responseData,"data-=-=")
        this.updateItemList(responseData);
  
        this.loading.value = false;
         return responseData
    }

   
    async loadexchangeItem( loginUserId: string) {

        this.loading.value = true;

        this.offset = 0;
        
        const responseData = await PsApiService.getExchange<Product>(new Product(), loginUserId);

        console.log(responseData,"data-=-=")
        this.updateItemList(responseData);

        this.loading.value = false;

    }
    async resetAddToCartItemList(loginUserId: string) {

        this.offset = 0;

        this.loading.value = true;

        const responseData = await PsApiService.getAddToCartList<Product>(new Product(), loginUserId);

        this.updateItemList(responseData);

        this.loading.value = false;

        return this.item;

    }

    async postAddToCart(itemId, userId) {
        const parmaHolder = new AddToCartParameterHolder;
        parmaHolder.itemId = itemId;
        parmaHolder.userId = userId;

        const responseData = await PsApiService.postAddToCart<Product>(new Product(),  parmaHolder.toMap());
        console.log()
        return responseData;
    }

}

export const AddToCartItemProviderSymbol = Symbol('AddToCartItemProvider')
export const createAddToCartItemProviderState = () => {
    return reactive(new AddToCartItemProvider())
}
export const loadAddToCartItemList = () => {
    return reactive(new AddToCartItemProvider())
}

export const useAddToCartItemProviderState = () => inject(AddToCartItemProviderSymbol) as AddToCartItemProvider
export const provideAddToCartItemProviderState = () => provide(
    AddToCartItemProviderSymbol,
    createAddToCartItemProviderState()
)